import Button from "@mui/material/Button";
import ResponsiveDialog from "../_atoms/ResponsiveDialog";
import { useMoveFileToFolderModal } from "../../store/modal-context";
import DriveFolderUploadOutlinedIcon from '@mui/icons-material/DriveFolderUploadOutlined';
import { Alert, Stack, Typography } from "@mui/material";
import FolderSelectorList from "../folders/FolderSelectorList";
import useApiHook from "../../hooks/useApiHook";
import { useEffect, useState } from "react";

const MoveFileToFolderDialog = () => {
    const { isOpen, closeModal, payload } = useMoveFileToFolderModal();
    const {
        response: moveResponse,
        makeRequest: makeMoveRequest,
        loading: moveLoading,
        error: moveError
    } = useApiHook();
    const [selectedFolderId, setSelectedFolderId] = useState(null);
    const [submitRequested, setSubmitRequested] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        setSelectedFolderId(payload?.folderId ?? null);
        setSubmitRequested(false);
    }, [isOpen, payload?.folderId]);

    useEffect(() => {
        if (!isOpen || !submitRequested || !moveResponse || moveResponse.state !== 'success') {
            return;
        }

        if (payload?.onSuccess) {
            payload.onSuccess();
        }

        setSubmitRequested(false);
        closeModal();
    }, [closeModal, isOpen, moveResponse, payload, submitRequested]);

    const onSelectHandler = (_, nextSelectedFolderId) => {
        setSelectedFolderId(nextSelectedFolderId);
    };

    const onConfirmHandler = () => {
        setSubmitRequested(true);
        makeMoveRequest('/folder/move-file', 'post', {
            fileId: payload?.fileId,
            folderId: selectedFolderId
        });
    };

    return (
        <ResponsiveDialog
            title={<Stack direction="row" alignItems="center" spacing={1}><DriveFolderUploadOutlinedIcon fontSize="large" /> <Typography variant="h5">Sposta file</Typography></Stack>}
            isOpen={isOpen}
            onClose={closeModal}
            actions={(
                <>
                    <Button size="large" variant="contained" onClick={onConfirmHandler} disabled={moveLoading || !payload?.fileId}>
                        Seleziona
                    </Button>
                    <Button size="large" onClick={closeModal}>
                        Annulla
                    </Button>
                </>
            )}
        >
            <Stack width="100%" height="100%" flexGrow={1} alignItems="center">
                <div data-file-id={payload?.fileId ?? ""} />
                <Typography width="100%" textAlign="left" variant="h6">Seleziona una cartella:</Typography>
                <Typography width="100%" textAlign="left" variant="body2" sx={{ opacity: 0.5 }}>
                    Stai spostando il file <strong>{payload?.fileName}</strong>.
                </Typography>
                <Typography width="100%" textAlign="left" variant="body2" mt={1} sx={{ opacity: 0.5 }}>
                    Se non selezioni alcuna cartella, il file verra spostato nella cartella principale.
                </Typography>
                {moveError && (
                    <Alert severity="error" sx={{ mt: 2, width: "100%" }}>
                        Impossibile spostare il file. Riprova.
                    </Alert>
                )}
                <Stack mt={2} width="300px">
                    <FolderSelectorList
                        isActive={isOpen}
                        selectedFolderId={selectedFolderId}
                        onSelect={onSelectHandler}
                    />
                </Stack>
            </Stack>
        </ResponsiveDialog>
    );
};

export default MoveFileToFolderDialog;
